import DevicesPage from './devices-page';

export default DevicesPage;